import {DiagramSubtypeLabels, getFullName, Map, User, MAP_GROUPS} from '@q9elements/ui-kit/common';
import {Column, SORT_ORDER, TableConfig} from '@q9elements/ui-kit/components';
import {capitalize} from 'lodash';

import {AGENT_SUBTYPES, COMMON_SUBTYPES, SUBTYPES} from './maps';

export enum MAP_TABS {
  ACTIVE = 'active',
  DELETED = 'deleted',
  SPACE = 'org'
}

export const MAP_SELECT_ALL = 'All';

export const COLUMNS: Column[] = [
  {
    key: 'name',
    title: 'MAP.NAME_HEADER',
    flex: 2,
    enableSort: true,
    sticky: true
  },
  {
    key: 'type',
    title: 'GENERAL.TYPE',
    enableSort: true,
    transform: (row: Map & {subtype?: SUBTYPES}) => {
      if (!row.subtype) {
        return row.type === COMMON_SUBTYPES.UPN ? COMMON_SUBTYPES.UPN : capitalize(row.type);
      }

      return DiagramSubtypeLabels[row.subtype];
    }
  },
  {
    key: 'owner',
    title: 'MAP.OWNER_HEADER',
    enableSort: true,
    transform: (row: Map) => getFullName(row.author as User)
  },
  {
    key: 'state',
    enableSort: true,
    flex: 0.5,
    title: 'MAP.STATE_HEADER',
    transform: (row: Map) => capitalize(row.state)
  },
  {
    key: 'role',
    flex: 0.5,
    enableSort: true,
    title: 'MAP.ACCESS_HEADER'
  },
  {
    key: 'tags',
    title: 'Tags'
  }
];

export const TABLE_CONFIG: TableConfig = {
  enableServerPagination: true,
  enableFiltering: true,
  enableSorting: true,
  columns: COLUMNS,
  sortBy: {key: 'name', order: SORT_ORDER.ASC},
  getSortParam(key: string, order: string): {[p: string]: string} {
    return {sort: `${key} ${order.toUpperCase()}`};
  }
};

export const agentsDiagramsSelectConfig = {
  isAutoPanelWidth: true,
  defaultOption: {
    label: MAP_SELECT_ALL,
    value: MAP_SELECT_ALL.toLocaleLowerCase()
  },
  options: [
    {
      label: DiagramSubtypeLabels[AGENT_SUBTYPES.AGENT_INSTRUCTION],
      value: AGENT_SUBTYPES.AGENT_INSTRUCTION,
      subtype: AGENT_SUBTYPES.AGENT_INSTRUCTION,
      group: MAP_GROUPS.AGENT_DIAGRAMS
    },
    {
      label: DiagramSubtypeLabels[AGENT_SUBTYPES.AGENT_INTERACTION],
      value: AGENT_SUBTYPES.AGENT_INTERACTION,
      subtype: AGENT_SUBTYPES.AGENT_INTERACTION,
      group: MAP_GROUPS.AGENT_DIAGRAMS
    }
  ]
};

export const commonDiagramsSelectConfig = {
  isAutoPanelWidth: true,
  defaultOption: {
    label: MAP_SELECT_ALL,
    value: MAP_SELECT_ALL.toLocaleLowerCase()
  },
  options: [
    {
      label: DiagramSubtypeLabels[COMMON_SUBTYPES.UPN],
      value: COMMON_SUBTYPES.UPN,
      subtype: COMMON_SUBTYPES.UPN,
      group: MAP_GROUPS.COMMON_DIAGRAMS
    },
    {
      label: DiagramSubtypeLabels[COMMON_SUBTYPES.CAPABILITY],
      value: COMMON_SUBTYPES.CAPABILITY,
      subtype: COMMON_SUBTYPES.CAPABILITY,
      group: MAP_GROUPS.COMMON_DIAGRAMS
    },
    {
      label: DiagramSubtypeLabels[COMMON_SUBTYPES.CUSTOMER_JOURNEY],
      value: COMMON_SUBTYPES.CUSTOMER_JOURNEY,
      subtype: COMMON_SUBTYPES.CUSTOMER_JOURNEY,
      group: MAP_GROUPS.COMMON_DIAGRAMS
    },
    {
      label: DiagramSubtypeLabels[COMMON_SUBTYPES.SYSTEM_ARCHITECTURE],
      value: COMMON_SUBTYPES.SYSTEM_ARCHITECTURE,
      subtype: COMMON_SUBTYPES.SYSTEM_ARCHITECTURE,
      group: MAP_GROUPS.COMMON_DIAGRAMS
    },
    {
      label: DiagramSubtypeLabels[COMMON_SUBTYPES.DATA_MODEL],
      value: COMMON_SUBTYPES.DATA_MODEL,
      subtype: COMMON_SUBTYPES.DATA_MODEL,
      group: MAP_GROUPS.COMMON_DIAGRAMS
    },
    {
      label: DiagramSubtypeLabels[COMMON_SUBTYPES.INTERACTION_FLOW],
      value: COMMON_SUBTYPES.INTERACTION_FLOW,
      subtype: COMMON_SUBTYPES.INTERACTION_FLOW,
      group: MAP_GROUPS.COMMON_DIAGRAMS
    },
    {
      label: DiagramSubtypeLabels[COMMON_SUBTYPES.WHITEBOARD],
      value: COMMON_SUBTYPES.WHITEBOARD,
      subtype: COMMON_SUBTYPES.WHITEBOARD,
      group: MAP_GROUPS.COMMON_DIAGRAMS
    }
  ]
};

export const allDiagramsSelectConfig = {
  isAutoPanelWidth: true,
  defaultOption: {
    label: MAP_SELECT_ALL,
    value: MAP_SELECT_ALL.toLocaleLowerCase()
  },

  options: [...agentsDiagramsSelectConfig.options, ...commonDiagramsSelectConfig.options]
};
